module.exports = new __parcel__URL__("../treeDeletion.82359302.png").toString();